import { render, staticRenderFns } from "./ped-validation-info.vue?vue&type=template&id=574d080c&scoped=true"
import script from "./ped-validation-info.vue?vue&type=script&lang=js"
export * from "./ped-validation-info.vue?vue&type=script&lang=js"
import style0 from "./ped-validation-info.vue?vue&type=style&index=0&id=574d080c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574d080c",
  null
  
)

export default component.exports